<template>
    <div id="anchor-reviews">
        <div class="bg-gray2 mb-2">
            <div class="row mx-0 align-items-stretch">
                <!--/* Zone Note moyenne */-->
                <div
                    v-if="reviewsStatsAverage"
                    id="stats-average"
                    class="col-12 col-md-4 d-md-flex p-1 p-md-2"
                >
                    <device-rating-reviews
                        :title="reviewsMessages.ratingTitle"
                        :link-label="reviewsMessages.ratingLinkLabel"
                        :link-url="reviewsMessages.ratingLinkUrl"
                        :average="reviewsStatsAverage"
                        :text="reviewsStatsText"
                        :summary="summary"
                        :rating-results-height="1.375"
                    />
                </div>
                <div
                    v-if="summary"
                    id="reviews-summary"
                    class="col-12 col-md-8 p-1 p-md-2 border-separator d-flex flex-column justify-content-center"
                >
                    <p class="lead mb-0">
                        <span class="icon icon-ai-generative" aria-hidden="true" /> <strong>Résumé des {{ reviewCount }} avis</strong>
                    </p>
                    <p class="mb-0">
                        <strong>{{ summary }}</strong>
                    </p>
                    <p class="small mb-0 pb-0 disclaimer">
                        Ce résumé a été généré par intelligence artificielle à partir des textes des commentaires clients.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DeviceRatingReviews from "./DeviceRatingReviews.vue";

export default {
    name: "DeviceAverageRatingReviews",
    components: {DeviceRatingReviews},
    props: {
        reviewsMessages: {
            type: Object,
            required: true
        },
        reviewsStatsAverage: {
            type: Number,
            required: true
        },
        reviewCount: {
            type: Number,
            required: true
        },
        summary: {
            type: String,
            required: false,
            default: ""
        }
    },
    computed: {
        reviewsStatsText() {
            return this.reviewCount ? '(' + this.reviewCount + ' avis)' : '';
        }
    }
}
</script>
<style scoped lang="scss">

@import 'ob1_common';
@import 'ob1_variables';

/* Sert de "contenant" au pseudo-élément */
.border-separator {
    position: relative;
}

/* Mobile: séparateur horizontal avec 10px de marge aux extrémités */
.border-separator::before {
    content: "";
    position: absolute;
    left: $msh-size-10;
    right: $msh-size-10;
    top: 0;
    height: 1px;
    background: $gray-light-plus;
}

/* Desktop (>= md): séparateur vertical avec 10px de marge en haut/bas */
@media (min-width: #{map-get($grid-breakpoints, md)}) {
    .border-separator::before {
        top: $msh-size-30;
        bottom: $msh-size-30;
        left: 0;
        right: auto;
        width: 1px;
        height: auto;
        background: $gray-light-plus;
    }
}

.disclaimer {
    color: $gray-before-light;
}
</style>
